import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b0867454&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0867454')) {
      api.createRecord('b0867454', component.options)
    } else {
      api.reload('b0867454', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b0867454&", function () {
      api.rerender('b0867454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BXS9vb2G7h7a/JS/imageCarousel.vue"
export default component.exports